type ProseMirrorMark = {
  type: string;
  attrs?: Record<string, string | number | boolean | null>;
};

type ProseMirrorTextNode = {
  type: 'text';
  text?: string;
  marks?: ProseMirrorMark[];
};

type ProseMirrorNode =
  | {
      type: string;
      content?: ProseMirrorNode[];
    }
  | ProseMirrorTextNode;

function isTextNode(node: ProseMirrorNode): node is ProseMirrorTextNode {
  return node.type === 'text';
}

function hasContent(node: ProseMirrorNode): node is { type: string; content: ProseMirrorNode[] } {
  return Array.isArray((node as { content?: ProseMirrorNode[] }).content);
}

export const removeCommentMarksFromContent = (node: ProseMirrorNode | ProseMirrorNode[] | null) => {
  if (!node || typeof node !== 'object') {
    return node;
  }

  if (Array.isArray(node)) {
    return node.map(removeCommentMarksFromContent);
  }

  if (isTextNode(node) && node.marks) {
    const filteredMarks = node.marks.filter((mark) => mark.type !== 'commentThread');
    return {
      ...node,
      marks: filteredMarks.length > 0 ? filteredMarks : undefined,
    };
  }

  if (hasContent(node)) {
    return {
      ...node,
      content: removeCommentMarksFromContent(node.content),
    };
  }

  return node;
};
